import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICardReplacementFormMeta {
  PAN: FormInputMeta;
  sequenceNumber: FormInputMeta;
  expirationDate: FormInputMeta;
  client: FormInputMeta;
  PANGeneration: FormInputMeta;
  newPAN: FormInputMeta;
  newCard: FormInputMeta;
  newEffectiveDate: FormInputMeta;
  newExpirationDate: FormInputMeta;
  magstripeCardToSmartCard: FormInputMeta;
  replacementReason: FormInputMeta;
  replacementFee: FormInputMeta;
  replaceWithPINGeneration: FormInputMeta;
  replaceWithoutMaking: FormInputMeta;

  schema: any;
}

const CardReplacementFormMeta = {} as ICardReplacementFormMeta;

CardReplacementFormMeta.PAN = {
  name: "PAN",
  type: "select",
  label: "PAN / Numéro de Carte",
  options: [
    {
      label: "PAN 1",
      value: "pan-1"
    },
    {
      label: "PAN 2",
      value: "pan-2"
    },
    {
      label: "PAN 3",
      value: "pan-3"
    },
  ],
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.sequenceNumber = {
  name: "sequenceNumber",
  type: "text",
  label: "Numéro Séquence",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.expirationDate = {
  name: "expirationDate",
  type: "date",
  label: "Date Expiration",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.client = {
  name: "client",
  type: "text",
  label: "Client",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.PANGeneration = {
  name: "PANGeneration",
  type: "select",
  label: "Génération PAN",
  options: [
    {
      label: "Manuel",
      value: "manual"
    },
    {
      label: "Automatique",
      value: "automatique"
    },
  ],
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.newPAN = {
  name: "newPAN",
  type: "text",
  label: "Nouv. PAN",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.newCard = {
  name: "newCard",
  type: "text",
  label: "Nom Carte",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.newEffectiveDate = {
  name: "newEffectiveDate",
  type: "date",
  label: "Nouv. Date Effective",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.newExpirationDate = {
  name: "newExpirationDate",
  type: "date",
  label: "Nouvelle date exp.",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.magstripeCardToSmartCard = {
  name: "magstripeCardToSmartCard",
  type: "checkbox",
  label: "Piste vers puce",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.replacementReason = {
  name: "replacementReason",
  type: "select",
  label: "Motif remplacement",
  options: [
    {
      label: "reason 1",
      value: "reason-1"
    },
    {
      label: "reason 2",
      value: "reason-2"
    },
  ],
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.replacementFee = {
  name: "replacementFee",
  type: "select",
  label: "Frais renouvellement",
  options: [
    {
      label: "fee 1",
      value: "fee-1"
    },
    {
      label: "fee 2",
      value: "fee-2"
    },
  ],
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.replaceWithPINGeneration = {
  name: "replaceWithPINGeneration",
  type: "checkbox",
  label: "Remplacer avec Génération PIN",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.replaceWithoutMaking = {
  name: "replaceWithoutMaking",
  type: "checkbox",
  label: "Remplacer sans fabrication",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

CardReplacementFormMeta.schema = yup.object().shape(getValidationSchema(CardReplacementFormMeta));

export default CardReplacementFormMeta;